<ng-container *ngIf="historyComparison">
    <div class="row">
        <div class="col-5">
            <div class="clientportal-app-card">
                <!-- HEADER -->
                <div class="clientportal-app-card-header">
                    <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1">
                        <h3 class="clientportal-app-card-title m-6">
                            <i class="fal fa-profile clientportal-app-card-title-icon"></i>
                            {{ 'PREVIOUS_DATA' | translate }}
                        </h3>
                    </div>
                </div>

                <!-- BODY -->
                <div id="cardCollapse-opportunityInfo" class="collapse show">
                    <div class="clientportal-app-card-body">
                        <!-- Creation Date -->
                        <div class="row">
                            <label class="text-muted small fw-medium">{{ 'CREATION_DATE' | translate }}</label>
                            <div class=" hover-td">
                                {{ historyComparison.previousData.creation.date | date:'dd/MM/yyyy - HH:mm' }}
                            </div>
                        </div>

                        <!-- Name -->
                        <div class="row">
                            <label class="text-muted small fw-medium">{{ 'NAME' | translate }}</label>
                            <div class="">
                                {{ historyComparison.previousData.creation.userDisplayName }}
                            </div>
                        </div>

                        <!-- Status -->
                        <div class="row">
                            <label class="text-muted small fw-medium">{{ 'STATUS' | translate }}</label>
                            <div class="">
                                <span *ngIf="historyComparison.previousData.data.status == 'Pending'">{{ 'CONTRACT_STATUS_PENDING' | translate }}</span>
                                <span *ngIf="historyComparison.previousData.data.status == 'Canceled'">{{'CONTRACT_STATUS_CANCELED' | translate }}</span>
                                <span *ngIf="historyComparison.previousData.data.status == 'Active'">{{ 'CONTRACT_STATUS_ACTIVE' | translate }}</span>
                                <span *ngIf="historyComparison.previousData.data.status == 'Accepted'">{{ 'CONTRACT_STATUS_ACCEPTED' | translate }}</span>
                                <span *ngIf="historyComparison.previousData.data.status == 'InActivation'">{{ 'CONTRACT_STATUS_IN_ACTIVATION' | translate }}</span>
                                <span *ngIf="historyComparison.previousData.data.status == 'Inserted'">{{ 'CONTRACT_STATUS_INSERTED' | translate }}</span>
                                <span *ngIf="historyComparison.previousData.data.status == 'PendingSupplier'">{{ 'CONTRACT_STATUS_PENDING_SUPPLIER' | translate }}</span>
                                <span *ngIf="historyComparison.previousData.data.status == 'Terminated'">{{ 'CONTRACT_STATUS_FINISHED' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ARROW -->
        <div class="col-2 text-center d-flex align-items-center justify-content-center">
            <i class="fa fa-arrow-right fa-3x my-4" aria-hidden="true"></i>
        </div>

        <div class="col-5">
            <div class="clientportal-app-card">
                <!-- HEADER -->
                <div class="clientportal-app-card-header">
                    <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1">
                        <h3 class="clientportal-app-card-title m-6">
                            <i class="fal fa-profile clientportal-app-card-title-icon"></i>
                            {{ 'ACTUAL_DATA' | translate }}
                        </h3>
                    </div>
                </div>

                <!-- BODY -->
                <div id="cardCollapse-opportunityInfo" class="collapse show">
                    <div class="clientportal-app-card-body">
                        <!-- Creation Date -->
                        <div class="row">
                            <label class="text-muted small fw-medium">{{ 'CREATION_DATE' | translate }}</label>
                            <div class=" hover-td">
                                {{ historyComparison.laterData.creation.date | date:'dd/MM/yyyy - HH:mm' }}
                            </div>
                        </div>

                        <!-- Name -->
                        <div class="row">
                            <label class="text-muted small fw-medium">{{ 'NAME' | translate }}</label>
                            <div class="">
                                {{ historyComparison.laterData.creation.userDisplayName }}
                            </div>
                        </div>

                        <!-- Status -->
                        <div class="row">
                            <label class="text-muted small fw-medium">{{ 'STATUS' | translate }}</label>
                            <div class="">
                                <span *ngIf="historyComparison.laterData.data.status == 'Pending'">{{ 'CONTRACT_STATUS_PENDING' | translate }}</span>
                                <span *ngIf="historyComparison.laterData.data.status == 'Canceled'">{{'CONTRACT_STATUS_CANCELED' | translate }}</span>
                                <span *ngIf="historyComparison.laterData.data.status == 'Active'">{{ 'CONTRACT_STATUS_ACTIVE' | translate }}</span>
                                <span *ngIf="historyComparison.laterData.data.status == 'Accepted'">{{ 'CONTRACT_STATUS_ACCEPTED' | translate }}</span>
                                <span *ngIf="historyComparison.laterData.data.status == 'InActivation'">{{ 'CONTRACT_STATUS_IN_ACTIVATION' | translate }}</span>
                                <span *ngIf="historyComparison.laterData.data.status == 'Inserted'">{{ 'CONTRACT_STATUS_INSERTED' | translate }}</span>
                                <span *ngIf="historyComparison.laterData.data.status == 'PendingSupplier'">{{ 'CONTRACT_STATUS_PENDING_SUPPLIER' | translate }}</span>
                                <span *ngIf="historyComparison.laterData.data.status == 'Terminated'">{{ 'CONTRACT_STATUS_FINISHED' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>